import React from 'react';
import useSearchQuery from '@magoosh/utils/use_search_query';

import Preview from './preview';
import Category from './category';

interface Props {}

const CategoryPage: React.FC<Props> = (props) => {
  const preview = useSearchQuery()['preview'] === 'true';

  if (preview) {
    return <Preview />;
  } else {
    return <Category />
  }
};

export default CategoryPage;
